import React from 'react';
import PropTypes from 'prop-types';
import { Breadcrumbs, Link, Box } from '@material-ui/core';
import { ArrowBack, NavigateBefore } from '@material-ui/icons';

import { makeStyles } from '@material-ui/core/styles';
import { darkTheme, lightTheme } from '../layout/themes';
import { useSelector } from 'react-redux';
import IconRadiusButton from '../CustomizedUIs/IconRadiusButton';
import GoBackButton from '../CustomizedUIs/GoBackButton';

const useStyles = makeStyles(theme => ({
    container: {
        display: 'flex',
        alignItems: 'flex-end'
    },
    link: {
        cursor: 'pointer',
        fontFamily: "UniviaPro-Medium",
        fontSize: "15px",
        fontWeight: 500,
        fontStretch: "normal",
        fontStyle: 'normal',
        lineHeight: 1.2,
        letterSpacing: "normal",
    },
}))

function Index({ path, getCategory, onBackClick, small }) {
    const classes = useStyles();
    const theme = useSelector((state) =>
        state.theme === 'dark' ? darkTheme : lightTheme
    );

    const onBreadcrumbClick = (event, id, index) => {
        event.preventDefault();
        if (index !== path.length - 1) {
            getCategory(id);
        }
    }

    if (!path) return null;
    return (
        <Box className={classes.container}>
            <GoBackButton
                style={{ marginRight: theme.spacing(2) }}
                onClick={onBackClick}
            />

            <Breadcrumbs separator={<NavigateBefore fontSize="small" />} aria-label="breadcrumb">
                {
                    path.map((item, index) => (
                        <Link
                            key={item.id + ''}
                            className={classes.link}
                            style={{
                                color: index === path.length - 1 ? '#8997b1' : '#237fc2'
                            }}
                            onClick={(event) => onBreadcrumbClick(event, item.id, index)}
                        >{item.name}</Link>
                    ))
                }
            </Breadcrumbs>
        </Box>
    );
}

Index.propTypes = {
    path: PropTypes.array,
    onBackClick: PropTypes.func.isRequired,
    small: PropTypes.bool
};

export default Index;
